export const extractVideoId = (url) => {
  // Extract the video ID from different URL formats
  const regex =
    /(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/(?:watch\?v=|shorts\/)|youtu\.be\/)([\w-]{11})/;
  const match = url.match(regex);
  return match ? match[1] : null;
};

export const getYouTubeVideoThumbnailById = (id) => {
  return `https://img.youtube.com/vi/${id}/sddefault.jpg`;
};

export function getYouTubeVideoId(url) {
  try {
    // Handle protocol-less URLs
    if (!/^https?:\/\//i.test(url)) {
      url = "https://" + url;
    }

    const parsedUrl = new URL(url);
    const host = parsedUrl.hostname.replace("www.", "");
    const path = parsedUrl.pathname;
    const params = parsedUrl.searchParams;

    // Check for youtu.be (shortened links)
    if (host === "youtu.be") {
      return path.split("/")[1] || null;
    }

    // Check for YouTube domains
    if (host.includes("youtube.")) {
      // Handle path patterns: /embed/ /live/ /shorts/ /v/
      const pathPatterns = ["/embed/", "/live/", "/shorts/", "/v/"];
      for (const pattern of pathPatterns) {
        if (path.startsWith(pattern)) {
          return path.split("/")[2] || null;
        }
      }

      // Handle watch links
      if (path === "/watch" && params.has("v")) {
        return params.get("v");
      }

      // Fallback: check 'v' parameter in any path
      if (params.has("v")) {
        return params.get("v");
      }
    }

    return null;
  } catch (e) {
    return null;
  }
}
